export default __webpack_public_path__ + "static/media/shop-05.007967ae.png";